import React from 'react'
import { Row, Col } from 'reactstrap'
import ContactForm from '../components/contact-form'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const WhatYouCanDo = (props) => {

    return (
        <div>
        <Row>
            <Col className="slidingPanelIntro" dangerouslySetInnerHTML={{__html:props.intro}} />
        </Row>
        <Row>
            <Col md="12" className="slidingPanelImage"><img src={props.image} /></Col>
        </Row>
        <Row>
            <Col lg="7" className="slidingPanelLeft" dangerouslySetInnerHTML={{__html:props.leftCol}} />
            <Col lg="5" className="slidingPanelRight">
                {/*<div className="donate">
                    <OutboundLink
                        className="charity"
                            href="https://www.justgiving.com/jbvcfoundation"
                        target='_blank'>
                    </OutboundLink>
                    <span className="big">Make a donation</span><br />
                    <span className="green">Help the Foundation bring out the best in everyone.</span><br />
                    <div className="readMore donateNow">
                        <OutboundLink
                            href="https://www.justgiving.com/jbvcfoundation "
                            target='_blank'>
                            Donate Now
                        </OutboundLink>
                        <div className="chevron green"></div>
                        <div className="chevron green"></div>
                    </div>
                </div>*/}
                <div dangerouslySetInnerHTML={{__html:props.rightCol}} />
                <ContactForm />
            </Col>
        </Row>
    </div>
    )

}

export default WhatYouCanDo



// WEBPACK FOOTER //
// ./src/components/what-you-can-do.js